<template>
    <div v-if='visibilityCheck' class="label-carrier">

            <h3 class="p-l-10 m-t-20">{{ name }}</h3>

        <div class="container-fluid">
            <shipping-label-item v-for="(option, index) in carrier_options"
                                 class="row"
                                 :selected="option.selected"
                                 :name="option.option_type"
                                 :carrier_weight_options="option.carrier_weight_options"
                                 @select="select(index)"
                                 @weightchange="(wt) => pricechange(index, wt)"
            >
            </shipping-label-item>
        </div>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .label-carrier {

        &:not(:last-child) {
            margin-bottom: 20px;
        }

        &:last-child .label-item:last-child {
            border-bottom-color: transparent;
        }

        .label-item {
            border-bottom: 1px solid $border-gray;

            &.selected {
               // color: white;
                background-color: $light-blue-selected;
                border-radius: 2px;
                border-color: transparent;
                font-weight: 700;
            }

            &:not(.selected) {
                &:hover {
                    background: $light-blue-hoover;
                }
            }
        }
    }

</style>`

<script>
    export default{
        props: [ 'name', 'carrier_options', 'index', 'speedee_account' ],

        data: function() {
            return {
            }
        },
        computed: {
            visibilityCheck: function() {

                if (this.name !== 'SpeeDee') {
                    return true;
                } else if (this.speedee_account == '1') {
                    return true;
                } else {
                    return false;
                }

            }
        },
        methods: {
            select: function(carrierOptionIndex) {
                this.$emit('select', this.index, carrierOptionIndex);
            },
            pricechange: function(carrierOptionIndex, weightOptionIndex) {
                this.$emit('updateweightvalue', this.index, carrierOptionIndex, weightOptionIndex);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// shipping-label-carrier.vue?7a46f2f6